import { Action } from '@ngrx/store';
import * as StatusActions from './../actions/status-action-data.actions';
import { AppState } from '../state/App.state';
import { StatusActionData } from '../models/status-actions.model';

const initialState = {
    fire: {
        sfsp_long: {
            is_call_made: false,
            actions_list: []
        },
    },
    marine: {
        specific_voyage: {
            is_call_made: false,
            actions_list: []
        },
        OpenPolicyMarine: {
            is_call_made: false,
            actions_list: []
        },
        MarineSTOP: {
            is_call_made: false,
            actions_list: []
        },
    },
    wc: {
        EmployeeCompensationInsurance: {
            is_call_made: false,
            actions_list: []
        },
    }
}
export function statusActionsDataReducer(state: StatusActionData = initialState, action: StatusActions.Actions) {

    switch (action.type) {
        case StatusActions.GET_STATUS_ACTIONS_DATA:
            return Object.assign({}, state, action.payload);
        default:
            return state;
    }
}

export const selectStatusActionsData = (state: AppState) => state.statusActionsData;
//export const selectLobAndProductStatusCall = (state:AppState) =>state.statusActionsData[]
